var React = require('react');

function SearchInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinecap":"square","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"},[React.createElement("circle",{"cx":"26","cy":"26","r":"21","key":0}),React.createElement("path",{"d":"M41 41l17.678 17.678","key":1})]));
}

SearchInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = SearchInline;

SearchInline.default = SearchInline;
